/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskProfileDimensionRiskUpdate
 */
export interface RiskProfileDimensionRiskUpdate {
  /**
   *
   * @type {number}
   * @memberof RiskProfileDimensionRiskUpdate
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskProfileDimensionRiskUpdate
   */
  overrideRiskLabel?: number | null;
}

/**
 * Check if a given object implements the RiskProfileDimensionRiskUpdate interface.
 */
export function instanceOfRiskProfileDimensionRiskUpdate(value: object): value is RiskProfileDimensionRiskUpdate {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function RiskProfileDimensionRiskUpdateFromJSON(json: any): RiskProfileDimensionRiskUpdate {
  return RiskProfileDimensionRiskUpdateFromJSONTyped(json, false);
}

export function RiskProfileDimensionRiskUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskProfileDimensionRiskUpdate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    overrideRiskLabel: json['override_risk_label'] == null ? undefined : json['override_risk_label'],
  };
}

export function RiskProfileDimensionRiskUpdateToJSON(value?: Omit<RiskProfileDimensionRiskUpdate, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    override_risk_label: value['overrideRiskLabel'],
  };
}
